import script from "./SearchableDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchableDropdown.vue?vue&type=script&setup=true&lang=js"

import "./SearchableDropdown.vue?vue&type=style&index=0&id=62a2451a&scoped=true&lang=css"
script.__scopeId = "data-v-62a2451a"

export default script